const lineage = {
  image: {
    'large': 'https://wstatic-cdn.plaync.com/lineage/v1/img/common/bi-lineageremaster-type1.png',
    'medium': 'https://wstatic-cdn.plaync.com/lineage/v1/img/common/bi-lineageremaster-type1.png',
    'mediumSticky': 'https://wstatic-cdn.plaync.com/lineage/v1/img/common/bi-lineageremaster-type2.png',
    'lnb': 'https://wstatic-cdn.plaync.com/lineage/v1/img/common/bi-lineageremaster-type2.png'
  },
  size: {
    'width': 84,
    'height': 35,
    'marginTop': 11
  },
  color: {
    'large': 'rgba(0,0,0,0.5)',
    'medium': 'rgba(0,0,0,0.5)',
    'mediumSticky': '#aa8060',
    'lnb': '#aa8060'
  },
  theme: {
    colorScheme: 'lineage'
  }
};

const lineage2 = {
  image: {
    'large': 'https://wstatic-cdn.plaync.com/lineage2/v1/img/common/icon-bi-lineage2.png',
    'medium': 'https://wstatic-cdn.plaync.com/lineage2/v1/img/common/icon-bi-lineage2.png',
    'mediumSticky': 'https://wstatic-cdn.plaync.com/lineage2/v1/img/common/icon-bi-lineage2.png',
    'lnb': 'https://wstatic-cdn.plaync.com/lineage2/v1/img/common/icon-bi-lineage2.png'
  },
  size: {
    'width': 130,
    'height': 22,
    'marginTop': 16
  },
  color: {
    'large': 'rgba(0,0,0,0.5)',
    'medium': 'rgba(0,0,0,0.5)',
    'mediumSticky': '#187d89',
    'lnb': '#187d89'
  },
  theme: {
    colorScheme: {
      default: '#187d89',
      defaultOn: '#53b0bb',
      start: '#16666f',
      startOn: '#16666f',
      subMenu: {
        hover: '#53b0bb',
        bar: '#53b0bb'
      }
    },
    style: {
      '.ncc-profile-info__level:after': {
        'content': '\' \'',
        'overflow': 'hidden',
        'display': 'inline-block',
        'width': '1px',
        'height': '10px',
        'margin': '0 10px',
        'opacity': '.3',
        'backgroundColor': '#fff'
      },
      '.ncc-profile-info__race': {
        'opacity': '.8',
        'fontWeight': '300',
        'lineHeight': '1',
        'color': '#fff',
        'fontSize': '12px',
        'marginLeft': '-4px'
      },
      '.ncc-profile-info__job ': {
        'opacity': '.8',
        'fontWeight': '300',
        'lineHeight': '1',
        'color': '#fff',
        'fontSize': '12px'
      }
    }
  }
};

const aion = {
  image: {
    'large': 'https://wstatic-cdn.plaync.com/aion/v1/img/common/aion_bi_v2.png',
    'medium': 'https://wstatic-cdn.plaync.com/aion/v1/img/common/aion_bi_v2.png',
    'mediumSticky': 'https://wstatic-cdn.plaync.com/aion/v1/img/common/aion_bi_v2.png',
    'lnb': 'https://wstatic-cdn.plaync.com/aion/v1/img/common/aion_bi_v2.png'
  },
  size: {
    'width': 81,
    'height': 30,
    'marginTop': 13
  },
  color: {
    'large': 'rgba(0,0,0,0.5)',
    'medium': 'rgba(0,0,0,0.5)',
    'mediumSticky': '#449fb9',
    'lnb': '#449FB9 '
  },
  theme: {
    colorScheme: {
      default: '#449fb9',
      defaultOn: '#2c8fac',
      start: '#449fb9',
      startOn: '#2c8fac',
      subMenu: {
        hover: '#7ddaf5',
        bar: '#7ddaf5'
      }
    },
    style: {
      '.ncc-profile-info__level:after': {
        'content': '\' \'',
        'overflow': 'hidden',
        'display': 'inline-block',
        'width': '1px',
        'height': '10px',
        'margin': '0 10px',
        'opacity': '.3',
        'backgroundColor': '#fff'
      },
      '.ncc-profile-info__race': {
        'opacity': '.8',
        'fontWeight': '300',
        'lineHeight': '1',
        'color': '#fff',
        'fontSize': '12px',
        'marginLeft': '-4px'
      },
      '.ncc-profile-info__job ': {
        'opacity': '.8',
        'fontWeight': '300',
        'lineHeight': '1',
        'color': '#fff',
        'fontSize': '12px'
      }
    }
  }
};

const bns = {
  // image: {
  //   'large': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns.png',
  //   'medium': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns.png',
  //   'mediumSticky': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns.png',
  //   'lnb': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns.png'
  // },
  // size: {
  //   'width': 80,
  //   'height': 36,
  //   'marginTop': 10
  // },

  image: {
    'large': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns-complete.png',
    'medium': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns-complete.png',
    'mediumSticky': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns-complete.png',
    'lnb': 'https://wstatic-cdn.plaync.com/bns/v1/img/common/bi-bns-complete.png'
  },
  size: {
    'width': 94,
    'height': 53,
    'marginTop': 0
  },

  color: {
    'mediumSticky': '#343493'
  },
  theme: {
    colorScheme: {
      default: '#343493'
    }
  }
};

export default {
  lineage,
  lineage2,
  aion,
  bns
};
